import { provideEventPlugins } from '@taiga-ui/event-plugins';
import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideStore } from '@ngxs/store';
import { StorageOption, withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { TUI_LANGUAGE, TUI_RUSSIAN_LANGUAGE } from '@taiga-ui/i18n';
import { of } from 'rxjs';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { WINDOW } from '@shared/providers/window.provider';
import { NAVIGATOR } from '@shared/providers/navigator.provider';
import { APP_ENVIRONMENT } from '@shared/providers/environment.provider';
import { DATE_SERVICE_PROVIDER } from '@shared/services/date/date.service';
import { MomentDateService } from '@shared/services/date/moment-date.service';
import { registerLocaleData } from '@angular/common';

import localeRu from '@angular/common/locales/ru';

import { routes } from './app.routes';
import { AuthState } from './store/auth/auth.state';
import { httpInterceptor } from './http.interceptor';
import { JournalState } from './modules/journal/store/journal.state';
import { environment } from '../environments/environment';
import { ServerWindowMock } from './mock/server-window-mock';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TUI_NUMBER_FORMAT } from '@taiga-ui/core';

registerLocaleData(localeRu);
export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_ENVIRONMENT,
      useFactory: () => environment,
    },
    {
      provide: WINDOW,
      useFactory: () => (typeof window !== 'undefined' ? window : new ServerWindowMock()),
    },
    {
      provide: NAVIGATOR,
      useFactory: () =>
        typeof navigator !== 'undefined' ? navigator : ({} as Navigator),
    },
    {
      provide: TUI_LANGUAGE,
      useValue: of(TUI_RUSSIAN_LANGUAGE),
    },
    {
      provide: DATE_SERVICE_PROVIDER,
      useClass: MomentDateService,
    },
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([httpInterceptor])),
    provideStore(
      [AuthState, JournalState],
      withNgxsStoragePlugin({
        keys: ['auth', 'journal'],
        storage: StorageOption.LocalStorage,
      }),
      withNgxsReduxDevtoolsPlugin({
        disabled: false,
      }),
    ),
    provideServiceWorker('my-service-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideEventPlugins(),
    {
      provide: TUI_NUMBER_FORMAT,
      useValue: of({
        precision: 2,
        rounding: 'round',
        decimalMode: 'pad',
        thousandSeparator: ' ',
        decimalSeparator: ',',
      }),
    },
  ],
};
